import React from 'react';
import { Outlet, useLocation } from "react-router-dom";
import Footer from './footer/footer';

function MainLayout() {
    const location = useLocation();
    const isProfilePage = ['/contact-us', '/product', '/products', '/'].includes(location.pathname);

    return (
        <>
            <main>
                <Outlet />
            </main>
            {isProfilePage && (
                <div className="home-footer mt-10">
                    <Footer />
                </div>
            )}
        </>
    );
}

export default MainLayout;
